// Cálculo puro da aba Evolução (snapshot mensal de itens).
export function variacaoPct(atual, anterior) {
    if (anterior == null || Number(anterior) === 0) return null;
    return ((Number(atual) - Number(anterior)) / Number(anterior)) * 100;
}

export function comVariacao(serie) {
    return (serie || []).map((p, i) => ({
        ...p,
        variacao: i === 0 ? null : variacaoPct(p.valor_total, serie[i - 1].valor_total),
    }));
}
